import { FONT_WEIGHT_OPTIONS } from './token-options.js';
export const BADGE_FIELDS = [
    {
        key: 'badge.outline.radius',
        group: '테두리 배지',
        label: '모서리 둥글기',
        help: '방송·상품 카드와 라운지 글의 카테고리 배지, 방송 카드 시청자 수 배지(테두리 배지 OutlineBadge)의 모서리 둥글기',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.xs-plus',
        min: 0,
        max: 40,
    },
    {
        key: 'badge.outline.paddingX',
        group: '테두리 배지',
        label: '좌우 안쪽 여백',
        help: '테두리 배지 글자 양옆의 여백',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.s',
        min: 0,
        max: 24,
    },
    {
        key: 'badge.outline.paddingY',
        group: '테두리 배지',
        label: '위아래 안쪽 여백',
        help: '테두리 배지 글자 위아래의 여백',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.xxs',
        min: 0,
        max: 16,
    },
    {
        key: 'badge.outline.fontSize',
        group: '테두리 배지',
        label: '글자 크기',
        help: '테두리 배지 글자 크기. 화면에서 글자 크기를 따로 정한 배지는 그대로',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.3xs',
        min: 8,
        max: 20,
    },
    {
        key: 'badge.outline.fontWeight',
        group: '테두리 배지',
        label: '글자 굵기',
        help: '테두리 배지 글자 굵기',
        type: 'enum',
        defaultValue: 'bold',
        options: FONT_WEIGHT_OPTIONS,
    },
    {
        key: 'badge.live.radius',
        group: 'LIVE 배지',
        label: '모서리 둥글기',
        help: '홈·라이브 더보기의 진행중 방송 카드 왼쪽 위 LIVE 배지의 모서리 둥글기. 색은 화면 설정 > 공통 "LIVE 배지 색"',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.xs',
        min: 0,
        max: 40,
    },
    {
        key: 'badge.live.paddingX',
        group: 'LIVE 배지',
        label: '좌우 안쪽 여백',
        help: 'LIVE 글자 양옆의 여백',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.xs',
        min: 0,
        max: 16,
    },
    {
        key: 'badge.viewerCount.backgroundOpacity',
        group: '시청자 수 배지',
        label: '바탕 진하기',
        help: '라이브 방송 화면 위쪽의 시청자 수 배지(ViewerCountBadge) 검정 바탕의 불투명도. 작을수록 뒤의 방송 화면이 더 비친다',
        type: 'enum',
        defaultValue: '80',
        options: [
            { value: '60', label: '60%' },
            { value: '70', label: '70%' },
            { value: '80', label: '80%' },
            { value: '90', label: '90%' },
            { value: '100', label: '100% (비치지 않음)' },
        ],
    },
    {
        key: 'badge.scheduledTime.height',
        group: '예정 시각 배지',
        label: '높이',
        help: '홈·라이브 더보기의 예정 라이브 카드 왼쪽 위 시작 시각 배지(ScheduledTimeBadge)의 높이',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.xs',
        min: 16,
        max: 32,
    },
    {
        key: 'badge.scheduledTime.radius',
        group: '예정 시각 배지',
        label: '모서리 둥글기',
        help: '예정 라이브 카드 시작 시각 배지의 모서리 둥글기',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.xs-plus',
        min: 0,
        max: 40,
    },
];
//# sourceMappingURL=badge.js.map